import TutorialViewContainer from "app/pages/sales-intelligence/common-components/TutorialView/TutorialViewContainer";
import withTrackedMouseEvents from "app/pages/sales-intelligence/hoc/withTrackedMouseEvents";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";

const TutorialViewTracked = withTrackedMouseEvents(
    TutorialViewContainer,
    homePageTrackingService.cards.watchTutorialButton,
)<ViewModelMetadata>;

export default TutorialViewTracked;
